export { useFastForwardRateAsEasy } from "#use-fast-forward-rate-as-easy";
